import script from "./AccessIssueNotesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessIssueNotesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AccessIssueNotesDialog.vue?vue&type=style&index=0&id=0522b130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0522b130"]])

export default __exports__